/**
 * Profile permissions that are not nav pages but still appear as Read/Write
 * rows in the User Profile form, keyed by display name exactly like the nav
 * children are. The API enforces the same keys on the matching routes.
 *
 *  - Device Files: read = browse the device + download what it uploaded;
 *    write = queue uploads from the device.
 *  - ECM Faults:   read = view pulls and the auto-upload setting;
 *    write = pull on demand, switch auto-upload.
 */
export const FEATURE_PERMISSIONS = ['Device Files', 'ECM Faults']

export type PermissionLevel = 'read' | 'write'

// PURE helper — no hooks, safe inside render loops. Super admins have everything.
export const hasFeaturePermission = (
    userProfile: any,
    name: string,
    level: PermissionLevel
) =>
    userProfile?.superAdmin === true ||
    userProfile?.userProfilePermissions?.[name]?.[level] === true
